<template>
  <div class="wrapper t_info">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section text-center t_step">
        <div class="container md-card">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Guest Information</h2>
            </div>
            <md-steppers md-alternative md-linear :md-active-step.sync="active" :md-editable="false">
              <md-step id="first" md-label="First Step - Choose Check In&Out Dates" :md-editable="false" :md-done.sync="first">
              </md-step>
              <md-step id="second" md-label="Second Step - Select Room" :md-editable="false" :md-done.sync="second">
              </md-step>
              <md-step id="third" md-label="Third Step - Finish Information" :md-editable="false" :md-done.sync="third">
              </md-step>
            </md-steppers>
          </div>
        </div>
      </div>
      <div class="section text-center t_content">
        <md-card class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100 mx-auto text-left t_infoLeft">
              <h3>Step 3: 
                <md-button
                  href="javascript:void(0)"
                  v-on:click="goBack()"
                  class="md-orange md-sm pull-right"
                  ><md-icon>keyboard_backspace</md-icon> Go Back
                </md-button>
              </h3>
              <hr>
              <h4 class="title">Booking Information</h4>
              <md-list>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Check-In Date:</span>
                  <span class="md-list-item-text title text-left">{{resData.startDate}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Check-Out Date:</span>
                  <span class="md-list-item-text title text-left">{{resData.endDate}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Adult Count:</span>
                  <span class="md-list-item-text title text-left">{{resData.adult}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Children Count:</span>
                  <span class="md-list-item-text title text-left">{{resData.children}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Currency:</span>
                  <span class="md-list-item-text title text-left">$ US Dollar</span>
                </md-list-item>
              </md-list>
              <hr>
              <h4 class="title">Daily Rate</h4>
               <md-list>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Room:</span>
                  <span class="md-list-item-text title text-left">{{resData.name}}</span>
                </md-list-item>
                <md-list-item>
                  <span class="md-list-item-text title text-right">Average Daily Rate:</span>
                  <span class="md-list-item-text title text-left">$ {{resData.price}}.00</span>
                </md-list-item>
              </md-list>
              <hr>
              <h4 class="title">Bill</h4>
               <md-list>
                <md-list-item>
                  <h4 class="md-list-item-text title text-right">Total Charge:</h4>
                  <h4 class="md-list-item-text title text-left">$ {{getPrice}}</h4>
                </md-list-item>
                <md-list-item>
                  <h4 class="md-list-item-text title text-right">Tax:</h4>
                  <h4 class="md-list-item-text title text-left">$ {{getTax}}</h4>
                </md-list-item>
                <md-list-item>
                  <h4 class="md-list-item-text title text-right">Total:</h4>
                  <h4 class="md-list-item-text title text-left">$ {{getTotal}}</h4>
                </md-list-item>
              </md-list>
            </div>
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto t_infoRight">
              <div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
                <nav-tabs-card no-label>
                  <template slot="content">
                    <md-tabs md-sync-route class="md-warning" md-alignment="left">
                      <md-tab id="tab-home" md-label="Customer Information" md-icon="face">
                        <form novalidate @submit.prevent="validateUser">
                          <md-field :class="getValidationClass('firstName')">
                            <md-icon>person</md-icon>
                            <md-input :disabled="sending" name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" @change="setCardName()" placeholder="    First Name"/>
                            <div class="md-error" v-if="!$v.form.firstName.required">The first name is required</div>
                            <div class="md-error" v-else-if="!$v.form.firstName.minlength">Invalid first name</div>
                          </md-field>
                          <md-field :class="getValidationClass('lastName')">
                            <md-icon>person</md-icon>
                            <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.lastName" :disabled="sending"  placeholder="    Last Name"/>
                            <div class="md-error" v-if="!$v.form.lastName.required">The last name is required</div>
                            <div class="md-error" v-else-if="!$v.form.lastName.minlength">Invalid last name</div>
                          </md-field>
                          <md-field :class="getValidationClass('email')">
                            <md-icon>email</md-icon>
                            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending"  placeholder="    Email"/>
                            <div class="md-error" v-if="!$v.form.email.required">The email is required</div>
                            <div class="md-error" v-else-if="!$v.form.email.minlength">Invalid email</div>
                          </md-field>
                          <md-field :class="getValidationClass('phone')">
                            <md-icon>phone</md-icon>
                            <md-input type="phone" name="phone" id="phone" autocomplete="phone" v-model="form.phone" :disabled="sending"  placeholder="    Phone"/>
                            <div class="md-error" v-if="!$v.form.phone.required">The phone is required</div>
                            <div class="md-error" v-else-if="!$v.form.phone.minlength">Invalid phone</div>
                          </md-field>
                          <md-field :class="getValidationClass('note')" style="margin:13px 0!important;">
                            <md-icon>description</md-icon>
                            <md-textarea v-model="form.note" type="note" name="note" id="note" placeholder="    Notes"></md-textarea>
                            <div class="md-error" style="padding-top:10px;" v-if="!$v.form.note.minlength">The maxLength is 255.</div>
                          </md-field>
                          <VCreditCard @change="creditInfoChanged" @cardChanged="cardChanged"/>
                          <md-button
                            type="submit" :disabled="sending"
                            class="md-orange md-lg pull-right"
                            ><md-icon>payment</md-icon> Book
                          </md-button>
                        </form>
                      </md-tab>
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
          </div>
        </md-card>
      </div>
    </div>
    <modal v-if="classicModal" @close="classicModalHide">
      <template slot="header">
        <h4 class="modal-title">Pay With</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="classicModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-list class="t_order">
            <md-list-item>
              <div class="md-list-item-text text-right">Check-In Date:</div>
              <div class="md-list-item-text text-left">{{resData.startDate}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Check-Out Date:</div>
              <div class="md-list-item-text text-left">{{resData.endDate}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Room:</div>
              <div class="md-list-item-text text-left">{{resData.name}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Total:</div>
              <div class="md-list-item-text text-left">$ {{getTotal}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Name:</div>
              <div class="md-list-item-text text-left">{{form.firstName}} {{form.lastName}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Email:</div>
              <div class="md-list-item-text text-left">{{form.email}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Phone:</div>
              <div class="md-list-item-text text-left">{{form.phone}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Note:</div>
              <div class="md-list-item-text text-left">{{form.note}}</div>
            </md-list-item>
            <hr>
            <md-list-item>
              <div class="md-list-item-text text-right">Card Type:</div>
              <div class="md-list-item-text text-left">{{card.cardName}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Card Number:</div>
              <div class="md-list-item-text text-left">{{getCard}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Card Name:</div>
              <div class="md-list-item-text text-left">{{card.name}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Card Expiration:</div>
              <div class="md-list-item-text text-left">{{card.expiration}}</div>
            </md-list-item>
            <md-list-item>
              <div class="md-list-item-text text-right">Card Security Code:</div>
              <div class="md-list-item-text text-left">***</div>
              <!-- <div class="md-list-item-text text-left">{{card.security}}</div> -->
            </md-list-item>
          </md-list>
          
      </template>

      <template slot="footer">
        <!-- <div class="t_paypal">
          <div id="paypal-button-container" @click="classicModalHide"></div>
        </div> -->
        <md-button
          class="md-orange"
          @click="setLoaded"
          >Book Confirm</md-button>
        <md-button
          class="md-danger md-simple"
          @click="classicModalHide"
          >Close</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { NavTabsCard } from "@/components"
  import { Modal } from "@/components"
  import { validationMixin } from 'vuelidate'
  import {required,email,minLength,maxLength,alpha, numeric,alphaNum} from 'vuelidate/lib/validators'
  import VCreditCard from 'v-credit-card'
  import 'v-credit-card/dist/VCreditCard.css'
  export default {
    data: () => {
      return {
        active: 'third',
        first: true,
        second: true,
        third: false,
        id: 0,
        withMIcon: null,
        loaded: false,
        classicModal: false,
        progressNum: 100,
        totalPrice: 0,
        price:0,
        tax:0,
        resData: {
          status: '',
          type: '',
          name: '',
          price: 0,
          count: 0,
          startDate: '',
          endDate: '',
          meetingPeriod: 0
        },
        form: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
          note: ''
          // address: null,
          // city: null,
          // postalcode: null,
          // state: null
        },
        userSaved: false,
        sending: false,
        lastUser: null,
        card: {
          name: '',
          cardNumber: '',
          expiration: '',
          security: '',
          cardName: ''
        }
      }
    },
    mixins: [validationMixin],
    validations: {
      form: {
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50)
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50)
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(13)
        },
        note: {
          maxLength: maxLength(254)
        }
      }
    },
    components: {
      NavTabsCard, 
      Modal,
      VCreditCard,
      'remote-js': {
        render (createElement) {
          var self = this
          return createElement('script', {
            attrs: { type: 'text/javascript', src: this.src },
            on: {
              load: function () {
                console.log('load js')
                self.$emit('load-js-finish')
              }
            }
          })
        },
        props: {
          src: { type: String, required: true }
        }
      }
    },
    props: {
      // jsUrl: { type: String, required: true}//,// 需要加载的外部url
      // jsLoadCallBack: Function// 外部js加载完成回调
    },
    computed: {
      getPrice: function () {
        return this.price = (this.resData.count * this.resData.price).toFixed(2)
      },
      getTax: function () {
        return this.tax = (this.resData.count * this.resData.price * 0.13).toFixed(2)
      },
      getTotal: function () {
        return this.totalPrice = (this.resData.count * this.resData.price + this.resData.count * this.resData.price * 0.13).toFixed(2)
      },
      getPeriod () {
        var period = '';
        if (this.resData.meetingPeriod === '1') {
          period = 'Full Day'
        } else if (this.resData.meetingPeriod === '2') {
          period = 'Morning 7am - 1pm'
        } else if (this.resData.meetingPeriod === '3') {
          period = 'Evening 4pm -12am'
        }
        return period
      },
      getCard: function () {
        return '************' + this.card.cardNumber.substring(15, this.card.cardNumber.length)
      }
    },
    methods: {
      getData: function () {
        this.id = this.$route.params.id
        // this.resData = this.$route.params
        return this.id
      },
      goBack: function () {
        this.$router.push({name:'showGuestList', params:{
          id: this.id,
          startDate: this.resData.startDate,
          endDate: this.resData.endDate,
          adult: this.resData.adult,
          children: this.resData.children
        }})
      },
      getNights: function (sDate1, sDate2) {
        var dateSpan, tempDate
        sDate1 = Date.parse(sDate1)
        sDate2 = Date.parse(sDate2)
        dateSpan = sDate2 - sDate1
        dateSpan = Math.abs(dateSpan)
        this.resData.count = Math.floor(dateSpan / (24 * 3600 * 1000))
        return this.resData.count
      },
      renderPaypal: function () {
        paypal.Buttons().render('body')
      },
      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid md-error': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.firstName = ''
        this.form.lastName = ''
        this.form.age = ''
        this.form.gender = ''
        this.form.email = ''
      },
      saveUser () {
        this.sending = true
        // Instead of this timeout, here you can call your API
        window.setTimeout(() => {
          this.lastUser = `${this.form.firstName} ${this.form.lastName}`
          this.userSaved = true
          this.sending = false
          // this.clearForm()
        }, 1500)
      },
      validateUser () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          if (this.checkCardInfo()) {
            this.saveUser()
            this.openModal()
          }
        }else{
          alert('Default Input not correct. Please make sure all required fields are filled out correctly!')
        }
      },
      classicModalHide() {
        this.classicModal = false;
      },
      openModal: function() {
        var that = this;
        this.classicModal = true;
        setTimeout(function(){
          // that.setLoaded()
        }, 1500);
      },
      setLoaded: function() {
        let that = this
        let data = JSON.stringify({
          tableType: 'guestHistory',
          roomName: that.resData.name,
          type: that.resData.type,
          invoice_id: that.id,
          typeName: 'guestRoom',
          checkInDate: that.resData.startDate,
          checkOutDate: that.resData.endDate,
          adult: that.resData.adult,
          children: that.resData.children,
          email: that.form.email,
          phone: that.form.phone,
          address: ' ',
          userName: that.form.firstName + ' ' + that.form.lastName,
          totalPrice: that.getTotal,
          price: that.getPrice,
          tax: that.getTax,
          cName: that.card.name,
          cNo: that.card.cardNumber,
          cExp: that.card.expiration,
          cCode: that.card.security,
          cType: that.card.cardName,
          note: that.form.note})
        // axios.post('/cgi-bin/php/executeNoRe.php', data).then((res) => {
        axios.post('https://www.orangetreetx.com/cgi-bin/php/executeNoRe.php', data).then((res) => {
          console.log(res.data)
          this.classicModal = false
          setTimeout(() => {
            if(res.data.status == 'COMPLETED') {
              that.$router.push({name:'completeGuestOrder', params:{
                type: 'guestHistory',
                orderId: res.data.orderId
              }})
            } else {
              that.$router.push({name:'chooseGuestDate'})
            }
          }, 500);
        }).catch((error) => {
          console.log(error)
        }).finally((res) => {
        })
        
      },
      creditInfoChanged(values) {
        for (const key in values) {
          this.card[key] = values[key]
        }
      },
      cardChanged(cardName) {
        this.card.cardName = cardName
      },
      setCardName: function(){
        this.card.name = this.form.firstName
      },
      checkCardInfo: function () {
        let isFill = true
        for (const key in this.card) {
          if(typeof(this.card[key]) != 'undefined') {
            switch (key) {
              case 'cardNumber':
                if (this.card[key].length < 15) {
                  isFill = false
                }
                break;
              case 'expiration':
                if (this.card[key].length < 5) {
                  isFill = false
                }
                break;
              case 'security':
                if (this.card[key].length < 2) {
                  isFill = false
                }
                break;
              default:
                break;
            }
          } else {
            isFill = false
            break
          }
        }
        return isFill
      }
    },
    created () {
      this.getData()
    },
    beforeMount() {
      this.resData.startDate = sessionStorage.getItem(this.id + 'start')
      this.resData.endDate = sessionStorage.getItem(this.id + 'end')
      this.resData.adult = sessionStorage.getItem(this.id + 'adult')
      this.resData.children = sessionStorage.getItem(this.id + 'children')
      this.resData.type = sessionStorage.getItem(this.id + 'type')
      this.resData.name = sessionStorage.getItem(this.id + 'name')
      this.resData.price = sessionStorage.getItem(this.id + 'price')
      // this.resData.count = sessionStorage.getItem(this.id + 'count')
      this.getNights(this.resData.startDate, this.resData.endDate)
    },
    mounted() {
      const script = document.createElement("script");
      script.src = "https://www.paypal.com/sdk/js?client-id=AWFoPvtQhdeYPDr7sMjSQohw4e1ToP3BLQsWfvnZQod2IrxBQ2x3WVr2uAKqOdfDDMLyjODUyPPNdyZI&components=buttons,funding-eligibility";
      // script.addEventListener("load", this.setLoaded);
      // document.head.appendChild(script);
    }
  }
</script>

<style lang="scss" scoped>
.page-header {
  height: auto;
}
.t_main {
  height: 100%;
  position: relative;
}
.t_content {
  padding-top: 0px;
  .container {
    margin-top: 0px;
    padding: 20px 20px 60px 20px;
  }
}

.t_roomList {
  text-align: left;
  clear: both;
  &:after{
    content: "." ; 
    display: block ;
    height: 0 ;
    clear: both ;
    visibility: hidden ;
  }
  padding: 25px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5)
}
.t_infoLeft{
  .t_rLeft, .t_rRight{
    width: 50%;
    float: left;
  }
  .t_rRight{
    text-align: right;
  }
  .md-list-item-text {
    &.text-right {
      flex-direction: row-reverse;
      padding-right:30px;
    }
    position: relative;
  }
}
.t_infoRight{
  .md-list-item-text {
    &.text-right {
      padding-left:30px;
    }
    position: relative;
  }
}
.t_step{
  padding: 100px 0px 10px;
  h2{
    padding-top:20px;
  }
}
.t_order{
  padding: 0 50px;
  .text-right{
    flex: 1;
  }
  .text-left{
    flex: 2;
    font-weight: 700;
  }
}
.md-field {
  .md-error{
    bottom: -8px;
    left: 50px;
  }
}
.t_paypal{
  display: block;
  width: 100%;
  margin: 0 50px;
}
</style>
<style lang="scss">
  .md-steppers{
    width: 100%;
    button{
      background-color: #fff!important;
      border: none;
      box-shadow: none;
      &:hover, &:active, &:link{
        background-color: #fff!important;
        border: none;
        box-shadow: none;
        cursor: pointer;
      }
    }
  }
  .md-steppers-navigation{
    box-shadow: none!important;
  }
  .t_info .md-list-item{
    .md-list-item-content{
      min-height: auto;
      padding:0!important;
    }
  }
</style>
